var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2793 8.45544C12.2714 7.14395 12.8766 6.15553 14.0988 5.42671C13.4153 4.46521 12.3811 3.93638 11.0179 3.83446C9.72723 3.73447 8.31508 4.5729 7.79801 4.5729C7.25156 4.5729 6.00198 3.86908 5.01877 3.86908C2.98966 3.89985 0.833252 5.45748 0.833252 8.62658C0.833252 9.56308 1.00757 10.5304 1.3562 11.5265C1.82234 12.838 3.50282 16.0513 5.25576 15.9994C6.17238 15.9782 6.82067 15.3609 8.01346 15.3609C9.17099 15.3609 9.77032 15.9994 10.7927 15.9994C12.5613 15.9744 14.0812 13.0533 14.5238 11.738C12.152 10.64 12.2793 8.52274 12.2793 8.45544ZM10.2208 2.59028C11.2138 1.43264 11.1237 0.378831 11.0943 0C10.2169 0.049998 9.20232 0.586515 8.62454 1.2461C7.988 1.95377 7.6139 2.82873 7.69421 3.81523C8.64217 3.88639 9.50786 3.40756 10.2208 2.59028Z",
    fill: "#393B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.6fd1340f8668bc622f469c8d53084b11.svg";
export { ForwardRef as ReactComponent };